const Header = (props) => {
    const { config,handleClick,defaultSort } = props;
    const clms = [];
    config.map(column =>
        clms.push(<th key={column.key}>
            {column.text}

        </th>)
    )
    return (
        <thead>
            <tr>
                {
                    config.map((element, index) => {
                        if (defaultSort.sort_column == element.key) {
                            let next_sort_type = "desc";
                            if(defaultSort.sort_type == "desc") {
                                next_sort_type = "asc";
                            }
                            return <th key={element.key} className="sorting_th" onClick={e => handleClick(element.key, next_sort_type,index)}>
                                {element.text}
                                <i className={`fa fa-sort-${defaultSort.sort_type}`}></i>
                            </th>
                        }
                        else if (element.sortable) {
                            return <th key={element.key} className="sorting_th" onClick={e => handleClick(element.key,'asc',index)}>
                                {element.text}
                                <i className="fa fa-sort"></i>
                            </th>
                        }
                        return <th key={element.key}>
                            {element.text}
                        </th>
                    })
                }
            </tr>
        </thead>
    );
}
export default Header;